import useBrands from 'data/hooks/useBrands';
import { useCallback, useEffect, useMemo } from 'react';
import { Props } from './types';

const useConnect = ({ allowAllOption, setSelectedId, value }: Props) => {
  const { brands, isLoading: isLoadingBrands } = useBrands();

  useEffect(() => {
    if (brands[0] && value === '') {
      setSelectedId(brands[0].id);
    }
  }, [setSelectedId, brands, value]);

  const options = useMemo(() => {
    const newOptions = [];

    if (allowAllOption) {
      newOptions.push({ label: 'All Restaurants', value: 'all-restaurants' });
    }

    brands.map((brand) => {
      newOptions.push({
        label: brand.name,
        value: brand.id,
      });
      return null;
    });

    return newOptions;
  }, [brands, allowAllOption]);

  const handleChangeSelect = useCallback(
    (event: React.ChangeEvent<{ label?: string; value: unknown }>) =>
      setSelectedId(event.target.value as string),
    [setSelectedId],
  );

  return {
    options,
    isLoadingBrands,
    handleChangeSelect,
  };
};

export default useConnect;
